import React from "react";
import ReactDOM from "react-dom/client";
import { firebaseService } from "./lib/firebase";
import { seedFirestore } from "./lib/seedFirestore";
import { SystemSettingsProvider } from "./lib/SystemSettingsContext";
import App from "./App";
import "./global.css";

// Initialize Firebase and seed data
if (firebaseService.isInitialized) {
  
  // Seed Firestore with default data
  seedFirestore().catch(console.error);
} else {
  console.error("Failed to initialize Firebase database");
}

ReactDOM.createRoot(document.getElementById("app")!).render(
  <React.StrictMode>
    <SystemSettingsProvider>
      <App />
    </SystemSettingsProvider>
  </React.StrictMode>
);